import script from "./ModalSchedule.vue?vue&type=script&setup=true&lang=ts"
export * from "./ModalSchedule.vue?vue&type=script&setup=true&lang=ts"

import "./ModalSchedule.vue?vue&type=style&index=0&id=279d96d0&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-279d96d0"]])

export default __exports__